import { useState } from "react";
import { X } from "lucide-react";
import { IconBtn } from "@/design-system/components/ui";
import { portalAuthApi } from "../api/auth";
import { usePortalAuth } from "../PortalAuthContext";

// Broker self-apply follow-ups — one-time "Application received" welcome for
// self-applied brokers. Renders only while /me flags showApplicationWelcome;
// dismissing (X) acknowledges it server-side (POST
// /auth/me/application-welcome-seen, which also stamps FirstLoginAt so the
// inline first-login panel stays suppressed) and refetches /me so it won't
// show again on the next render or session.
//
// Mirrors CertificationWelcomeModal, with one deliberate difference: it does
// NOT auto-acknowledge on mount — acknowledgement happens only on the user's
// dismissal, so the broker actually sees the message once.
export function ApplicationReceivedModal() {
  const auth = usePortalAuth();
  const [busy, setBusy] = useState(false);

  if (!auth.me?.showApplicationWelcome) return null;

  async function dismiss() {
    setBusy(true);
    try {
      await portalAuthApi.acknowledgeApplicationWelcome();
      await auth.refresh();
    } finally {
      setBusy(false);
    }
  }

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-onyx/50 p-space-4"
      data-testid="application-received-welcome"
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-label="Application received"
        className="relative max-w-lg w-full rounded-md bg-white-pure p-space-6 shadow-lg border-t-[2px] border-t-gold text-center"
      >
        <div className="absolute right-space-3 top-space-3">
          <IconBtn
            label="Dismiss"
            onClick={() => void dismiss()}
            disabled={busy}
            data-testid="application-received-dismiss"
          >
            <X size={16} aria-hidden />
          </IconBtn>
        </div>
        <h2 className="font-display font-bold text-h2 text-onyx m-0 uppercase tracking-label">
          Application received
        </h2>
        <p className="text-body text-gray-mid mt-space-3 max-w-reading mx-auto">
          Thanks for applying to Phoenix Capital. One of our team members will
          review your information and follow up with next steps soon.
        </p>
      </div>
    </div>
  );
}
